const UPDATE_RESOURCE_AVAILABILITIES_LOADING = 'book/UPDATE_RESOURCE_AVAILABILITIES_LOADING';
const UPDATE_RESOURCE_AVAILABILITIES = 'book/UPDATE_RESOURCE_AVAILABILITIES';

export default {
  UPDATE_RESOURCE_AVAILABILITIES_LOADING,
  UPDATE_RESOURCE_AVAILABILITIES
};
